import FeatureGates from '@atlaskit/feature-gate-js-client';
import { Journeys } from '@atlassian/app-provisioning';
import { SURFACE_ANALYTICS_PRODUCT_MAP } from '@atlassian/surface-analytics';
import type { Context } from '@atlassian/surface-sdk/types';

/**
 * For Skip benefits page experiment
 * https://hello.atlassian.net/wiki/spaces/ECON/pages/2796625371/Skip+benefits+page+better+show+value+in+confirmation+screen
 *
 * This function either returns a Journey value for enrolled users
 * or undefined so the caller can fallback to a default.
 */
export const getExperimentValues = (context: Context, targetProduct: string) => {
	const { isSiteAdmin, product } = context;

	if (
		!isSiteAdmin ||
		!['jira', 'confluence'].includes(product || '') ||
		targetProduct !== SURFACE_ANALYTICS_PRODUCT_MAP.products['jira-servicedesk.ondemand']
	) {
		return;
	}

	const experimentName = 'skip_benefits_page_experiment';
	try {
		const cohort: string = FeatureGates.getExperimentValue(
			experimentName,
			'cohort',
			'not-enrolled',
		);

		if (cohort === 'variation') {
			return {
				cohort,
				journeyOverride: Journeys.GET_STARTED,
			};
		} else if (cohort === 'control') {
			return {
				cohort,
				journeyOverride: Journeys.DECIDE,
			};
		}

		return {
			cohort: 'not-enrolled',
		};
	} catch (error) {
		Promise.reject(error);
	}
};
